import React, { useEffect, useRef, useState } from "react";
import {
  getFront,
  selectFeaturedTeam,
  selectFrontData,
  selectLoadingStatus,
} from "../state/reducers/NewFrontReducer";
import styled from "styled-components";
import Carousel from "../components/Carousel/Carousel";
import CarouselContainer from "../components/Carousel/CarouselContainer";
import SCTeamPlacingCard from "../components/Cards/SCTeamPlacingCard";
import {
  selectMagicNumber,
  ChangeMagicNumber,
} from "../state/reducers/UserSettingsReducer";
import { useAppDispatch, useAppSelector } from "../hooks";
import PlayerCard from "../components/Cards/PlayerCard";
import PositionCard from "../components/Cards/PositionCard";
import FeaturePlayerCard from "../components/Cards/FeaturePlayerCard";
import StatGraph from "../components/Graphs/StatGraph";
import FeaturedTeamContainer from "../components/FrontPage/FeaturedTeamContainer";
import RoundedCTA from "../components/CTAs/RoundedCTA";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { Button } from "@mui/material";
import { RoundedCTAContainer, PageContainer } from "../globals/styles";
import NavDrawer from "../components/Navigation/NavDrawer";
import NavItems from "../components/Navigation/NavItems";
import Header from "../components/Header/Header";
import SearchAutoComplete from "../components/Search/SearchAutoComplete";
import { Transition } from "react-transition-group";
import FrontFeaturedTeamContainer from "../components/FrontPage/FrontFeaturedTeamContainer";
import { RegisterPageView } from "../globals/Analytics";
import MyTransition from "../components/Theming/MyTransition";
import Fade from "../components/Theming/NewFadein";
import CSSTransition from "react-transition-group";
import Loading from "../components/Loading";
import PlayerList from "../components/Lists/PlayerList";
import OwnershipListItem from "../components/Lists/ListItems/OwnershipListItem";
import _ from "underscore";
import { CURRENT_SEASON } from "../globals/BBLData";

const transitionStyles = {
  entering: { opacity: 1 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};

const duration = 1000;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const MyHomeContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const WrappingContainer = styled.div`
  display: flex;
  flex-direction: column;
  maxwidth: 100%;
  row-gap: 1rem;
  @media (min-width: 800px) {
    flex-direction: row;
    column-gap: 1rem;
    .carousel-wrapper {
      width: calc(50% - 0.5rem);
    }
  }
`;

const FrontPage = () => {
  const dispatch = useAppDispatch();
  const [animate, setAnimate] = useState(false);
  const [done, setDone] = useState(false);

  RegisterPageView({ path: "/" });
  useEffect(() => {
    dispatch(getFront());
  }, []);
  const isloading = useAppSelector(selectLoadingStatus);
  const frontData = useAppSelector(selectFrontData);
  const featuredTeam = useAppSelector(selectFeaturedTeam);

  useEffect(() => {}, [isloading]);

  setTimeout(() => {
    if (isloading === "idle") {
      setAnimate(true);
    }
  }, 2000);

  let featuredPlayers = frontData.featuredPlayers
    ? frontData.featuredPlayers
    : [];
  if (featuredPlayers) {
    featuredPlayers = _.sortBy(featuredPlayers, function (player) {
      let points = 0;
      player.stats.map(function (stat) {
        if (stat.season === "2023-24") {
          if (stat.lastSeasonTotalPoints) {
            points = stat.lastSeasonTotalPoints;
          }
        }
      });
      return -points;
    });
  }

  console.log("featuredPlayers:", featuredPlayers);
  let lowbeplayers = frontData.LowBePlayers ? frontData.LowBePlayers : [];
  lowbeplayers = _.sortBy(lowbeplayers, function (player) {
    let scbe = 1000;
    player.stats.map(function (stat) {
      if (stat.season === CURRENT_SEASON) {
        if (stat.lastgame) {
          scbe = stat.lastgame.scbe;
        }
      }
    });
    return scbe;
  });
  const bestPlacings = frontData.bestPlacings ? frontData.bestPlacings : [];
  const lastRoundBestTeam = frontData.lastRoundBestTeam
    ? frontData.lastRoundBestTeam
    : {};
  const lastRoundBestPlacing = frontData.lastRoundsBestPlacing
    ? frontData.lastRoundsBestPlacing
    : {};
  const allplayers = frontData.allplayers ? frontData.allplayers : [];
  let batters = frontData.lastRoundBestBatters
    ? frontData.lastRoundBestBatters
    : [];

  batters = _.sortBy(batters, function (player) {
    let sr = 0;

    let totalRuns = 0;
    const thisseasonstat = player.stats.find(
      (stat) => stat.season === CURRENT_SEASON
    );

    if (thisseasonstat) {
      totalRuns = thisseasonstat.lastSeasonTotalRuns;
    }

    // if (player.batStrikeStat) {
    //   sr = player.batStrikeStat.avgSR;
    // }

    // return -sr;
    return -totalRuns;
  });
  let bowlers = frontData.lastRoundBestBowlers
    ? frontData.lastRoundBestBowlers
    : [];
  bowlers = _.sortBy(bowlers, function (player) {
    let wickets = 0;
    player.stats.map(function (stat) {
      if (stat.season === "2024-25") {
        if (stat.lastgame) {
          wickets = stat.lastSeasonTotalWickets;
        }
      }
    });

    return -wickets;
  });
  const mostViewedPlayers = frontData.mostViewedPlayers
    ? frontData.mostViewedPlayers
    : [];
  let highestOwnershipPlayers = frontData.highestOwnership
    ? frontData.highestOwnership
    : [];

  highestOwnershipPlayers = _.sortBy(
    highestOwnershipPlayers,
    function (player) {
      let ownership = 0;
      player.stats.map(function (stat) {
        if (stat.season === CURRENT_SEASON) {
          ownership = stat.ownershipPerc;
          // if (stat.lastgame) {
          //   ownership = stat.lastgame.ownPerc;
          // }
        }
      });

      return -ownership;
    }
  );
  return (
    <PageContainer>
      <Loading isLoading={isloading === "loading"} setDone={setDone} />
      <Header />
      <SearchAutoComplete players={allplayers} />
      <MyTransition location="/home" inProp={done}>
        <div
          style={{ display: "flex", flexDirection: "column", rowGap: "1rem" }}
        >
          <CarouselContainer
            title={""}
            description={""}
            icon={""}
            hideTop={true}
            hideWhite={true}
          >
            {featuredPlayers.map(function (featuredPlayer) {
              let positionstring = "";
              let newseasonstat = featuredPlayer.stats?.filter(function (stat) {
                return stat.season === "2024-25";
              });
              let theirstat = featuredPlayer.stats?.filter(function (stat) {
                return stat.season === "2023-24";
              });

              let avgpts = "";
              if (newseasonstat) {
                const lastgame = newseasonstat[0].lastgame;

                avgpts = (
                  lastgame?.total_points / lastgame?.total_games
                ).toFixed(2);
              }

              featuredPlayer.positions.map(function (position, index) {
                if (index !== 0) {
                  positionstring = positionstring + ", " + position.name;
                } else {
                  positionstring = position.name;
                }
              });

              return (
                <FeaturePlayerCard
                  player={featuredPlayer}
                  rightStats={[
                    {
                      label: "Total Pts",
                      valueField: (
                        <h2 style={{ marginBottom: "0", marginTop: 0 }}>
                          {newseasonstat[0]?.lastSeasonTotalPoints}
                        </h2>
                      ),
                    },
                    {
                      label: "AVG Pts",
                      valueField: (
                        <h2 style={{ marginBottom: "0", marginTop: 0 }}>
                          {avgpts}
                        </h2>
                      ),
                    },
                    {
                      label: "Price",
                      valueField: (
                        <h2 style={{ marginBottom: "0", marginTop: 0 }}>
                          {newseasonstat[0].price
                            ? newseasonstat[0].price.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              })
                            : ""}
                        </h2>
                      ),
                    },
                    {
                      label: "Position",
                      valueField: (
                        <h2 style={{ marginBottom: "0", marginTop: 0 }}>
                          {positionstring}
                        </h2>
                      ),
                    },
                  ]}
                />
              );
            })}
          </CarouselContainer>
          {/* <div style={{width: '50%'}}>
                        <PlayerList 
                            title={"Top Owned Players"}
                            children={featuredPlayers.map(function(featuredPlayer) {
                                return <OwnershipListItem player={featuredPlayer} ownershipPercentage={featuredPlayer.lastownership.top1000} />
                            })}
                        />
                    </div> */}

          <RoundedCTAContainer>
            <RoundedCTA
              Icon={
                <img
                  src={"/images/icons/sclogo-blue.svg"}
                  style={{ width: 48, height: 48 }}
                />
              }
              link="/scteams"
              text="SC Teams"
              newTab={false}
            />
            <RoundedCTA
              Icon={
                <CompareArrowsIcon
                  style={{ width: 48, height: 48, color: "#21ace1" }}
                />
              }
              link="/compareplayers"
              text="Compare Players"
            />
            <RoundedCTA
              Icon={
                <PersonSearchIcon
                  style={{ width: 48, height: 48, color: "#21ace1" }}
                />
              }
              link="/findplayers"
              text="Find A Player"
            />
            <RoundedCTA
              Icon={
                <img
                  src={"/images/icons/scpblogo.svg"}
                  style={{ width: 48, height: 48 }}
                />
              }
              link="https://scplaybook.com.au"
              text="SC News"
              newTab
            />
          </RoundedCTAContainer>
          {/* <CarouselContainer
            title={"Money Makers"}
            description={"Lowest BE Players"}
            icon={"Money Makers"}
            tooltipText={
              "The players with the lowest breakeven. They need to score the least to justify their price."
            }
          >
            {lowbeplayers.map(function (player) {
              let theirlastgame = null;
              player.stats.map(function (stat) {
                if (stat.season === CURRENT_SEASON) {
                  theirlastgame = stat.lastgame;
                }
              });

              return (
                <PlayerCard
                  player={player}
                  width={"200px"}
                  onPlusClick={(player) => console.log("click")}
                  onNavClick={(player) => console.log("nav click")}
                  theirlastgame={theirlastgame}
                />
              );
            })}
          </CarouselContainer> */}

          <WrappingContainer>
            <div className="carousel-wrapper">
              <CarouselContainer
                title={"Best Batters BBL13"}
                description={""}
                icon={"SC Teams"}
                tooltipText={"Seasons best batters - ranked by total Runs"}
              >
                {batters.map(function (bowler) {
                  console.log(`${bowler.lastname} batting card: `, bowler);
                  return (
                    <PositionCard
                      player={bowler}
                      width={"210px"}
                      onPlusClick={(player) => console.log("click")}
                      onNavClick={(player) => console.log("nav click")}
                      position={"BAT"}
                    />
                  );
                })}
              </CarouselContainer>
            </div>
            <div className="carousel-wrapper">
              <CarouselContainer
                title={"Best Bowlers BBL13"}
                description={""}
                icon={"SC Teams"}
                tooltipText={
                  "Last rounds best bowlers - ranked by last total wickets taken"
                }
              >
                {bowlers.map(function (bowler) {
                  return (
                    <PositionCard
                      player={bowler}
                      width={"210px"}
                      onPlusClick={(player) => console.log("click")}
                      onNavClick={(player) => console.log("nav click")}
                      position={"BWL"}
                    />
                  );
                })}
              </CarouselContainer>
            </div>
          </WrappingContainer>
          <CarouselContainer
            title={"Highest Owned Players"}
            description={"Highest Owned Players (Top 1k)"}
            icon={"Money Makers"}
            tooltipText={"The players that are owned by the most SC Teams."}
          >
            {highestOwnershipPlayers.map(function (player) {
              let theirlastgame = null;
              let lastseasonstat = null;
              player.stats.map(function (stat) {
                if (stat.season === CURRENT_SEASON) {
                  theirlastgame = stat.lastgame;
                  lastseasonstat = stat;
                }
              });
              console.log("highestOwnershipPlayers: ", {
                stats: player.stats,
                theirlastgame,
                lastseasonstat,
                player,
              });
              return (
                <PlayerCard
                  player={player}
                  width={"200px"}
                  onPlusClick={(player) => console.log("click")}
                  onNavClick={(player) => console.log("nav click")}
                  theirlastgame={theirlastgame}
                  stats={lastseasonstat}
                />
              );
            })}
          </CarouselContainer>
          <CarouselContainer
            title={"Most Viewed Players"}
            description={"Player's that have been checked out the most 😉"}
            icon={"SC Teams"}
            tooltipText={"Players who have been viewed the most recently"}
          >
            {mostViewedPlayers.map(function (player) {
              let theirlastgame = null;
              let lastseasonstat = null;
              player.stats.map(function (stat) {
                if (stat.season === "2022-23") {
                  theirlastgame = stat.lastgame;
                  lastseasonstat = stat;
                }
              });

              return (
                <PlayerCard
                  player={player}
                  width={"200px"}
                  onPlusClick={(player) => console.log("click")}
                  onNavClick={(player) => console.log("nav click")}
                  theirlastgame={theirlastgame}
                  stats={lastseasonstat}
                />
              );
            })}
          </CarouselContainer>

          {/* <FrontFeaturedTeamContainer
            featuredTeam={featuredTeam?.team ? featuredTeam.team : {}}
            playerOwnerships={
              featuredTeam?.ownerships ? featuredTeam.ownerships : []
            }
            placings={
              featuredTeam?.team?.placings ? featuredTeam.team.placings : []
            }
          /> */}
          {/* <CarouselContainer title={"Best SC Teams"} description={"Overall Best SC Teams"} icon={"SC Teams"}>
                    {bestPlacings.map(function(placing) {
                    return <SCTeamPlacingCard placing={placing} /> 
                    })}
                </CarouselContainer> */}
        </div>
      </MyTransition>
    </PageContainer>
  );
};

export default FrontPage;
